import * as Yup from "yup";

export const accountVerificationSchema = Yup.object().shape({
  code: Yup.string()
    .min(6, "Code should be 6 characters.")
    .max(6, "Code should be 6 characters.")
    .matches(/^\d+$/, "Code must be Numeric.")
    .required("Code is required."),
});
